'use strict';

export let ContactoRouteComponent = {
    selector: 'contactoRoute',
    template: require('./contacto-route.html'),
    controller: class {

        /*@ngInject*/
        constructor(ContactoService, ToasterService) {
            Object.assign(this, {ContactoService, ToasterService});
            this.mail = {nombre: '', telefono: '', email: '', ciudad: '', pais: '', mensaje: ''};
            this.enviardoMensaje = false;
            this.cleanForm();
        }


        sendMail(form) {
            if (form.$valid) {
                this.enviardoMensaje = true;
                this.ContactoService.sendMail(this.mail)
                    .then(res => {
                        this.mensajeEnviado = true;
                        this.ToasterService.popUp('success','E-Mail', 'Se ha enviado con éxito.');
                        // this.cleanForm();
                    })
                    .catch(err => this.ToasterService.error());
            } else {
                this.enviardoMensaje = false;
                this.ToasterService.popUp('info','Informacion', 'El formulario esta incompleto o no es válido.');
            }
        }

        cleanForm(){
            this.mail = {nombre: '', telefono: '', email: '', ciudad: '', pais: '', mensaje: ''};
        }
    }
};



// WEBPACK FOOTER //
// ./client/app/contacto-route/contacto-route.component.js